module.exports = __webpack_public_path__ + "img/logo.22c14ca4.png";